'use client';

import { track } from '@vercel/analytics';
import { ReactNode } from 'react';

interface ClickTrackerProps {
  children: ReactNode;
  eventName: string;
  data?: Record<string, string | number | boolean>;
}

/**
 * Wraps SSR content and tracks clicks via Vercel Analytics.
 * Uses display: contents so it doesn't affect layout.
 * The wrapped element (e.g. a link) remains fully server-rendered.
 */
export function ClickTracker({ children, eventName, data }: ClickTrackerProps) {
  const handleClick = () => {
    track(eventName, data);
  };

  return (
    <span className="contents" onClick={handleClick}>
      {children}
    </span>
  );
}
